/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EstateCardDto } from '../models/EstateCardDto';
import type { EstateDto } from '../models/EstateDto';
import type { EstateListMapResultModel } from '../models/EstateListMapResultModel';
import type { EstateListResultModel } from '../models/EstateListResultModel';
import type { SortOrder } from '../models/SortOrder';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EstatesService {

    /**
     * @param estateId
     * @param intake
     * @param sellerId
     * @param buyerId
     * @param valuation
     * @returns EstateDto Success
     * @throws ApiError
     */
    public static estatesGetEstate(
        estateId?: string,
        intake: boolean = false,
        sellerId?: string,
        buyerId?: string,
        valuation: boolean = false,
    ): CancelablePromise<EstateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Estates/GetEstate',
            query: {
                'estateId': estateId,
                'intake': intake,
                'sellerId': sellerId,
                'buyerId': buyerId,
                'valuation': valuation,
            },
        });
    }

    /**
     * @param page
     * @param areaIds
     * @param municipality
     * @param county
     * @param estateType
     * @param priceMin
     * @param priceMax
     * @param monthlyCostMin
     * @param monthlyCostMax
     * @param roomsMin
     * @param roomsMax
     * @param livingSpaceMin
     * @param livingSpaceMax
     * @param showSold
     * @param showOnlyHeadStart
     * @param extraSearch
     * @param propertyType
     * @param alignment
     * @param movingIn
     * @param plotAreaMin
     * @param plotAreaMax
     * @param customerId
     * @param brokerId
     * @param showGreenEstates
     * @param showBidding
     * @param sortOrder
     * @param drawnAreas
     * @returns EstateListResultModel Success
     * @throws ApiError
     */
    public static estatesGetForFilter(
        page?: number,
        areaIds?: string,
        municipality?: string,
        county?: string,
        estateType?: string,
        priceMin?: number,
        priceMax?: number,
        monthlyCostMin?: number,
        monthlyCostMax?: number,
        roomsMin?: number,
        roomsMax?: number,
        livingSpaceMin?: number,
        livingSpaceMax?: number,
        showSold?: boolean,
        showOnlyHeadStart?: boolean,
        extraSearch?: string,
        propertyType?: string,
        alignment?: string,
        movingIn?: string,
        plotAreaMin?: number,
        plotAreaMax?: number,
        customerId?: string,
        brokerId?: string,
        showGreenEstates?: boolean,
        showBidding?: boolean,
        sortOrder?: SortOrder,
        drawnAreas?: string,
    ): CancelablePromise<EstateListResultModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Estates/GetForFilter',
            query: {
                'page': page,
                'areaIds': areaIds,
                'municipality': municipality,
                'county': county,
                'estateType': estateType,
                'priceMin': priceMin,
                'priceMax': priceMax,
                'monthlyCostMin': monthlyCostMin,
                'monthlyCostMax': monthlyCostMax,
                'roomsMin': roomsMin,
                'roomsMax': roomsMax,
                'livingSpaceMin': livingSpaceMin,
                'livingSpaceMax': livingSpaceMax,
                'showSold': showSold,
                'showOnlyHeadStart': showOnlyHeadStart,
                'extraSearch': extraSearch,
                'propertyType': propertyType,
                'alignment': alignment,
                'movingIn': movingIn,
                'plotAreaMin': plotAreaMin,
                'plotAreaMax': plotAreaMax,
                'customerId': customerId,
                'brokerId': brokerId,
                'showGreenEstates': showGreenEstates,
                'showBidding': showBidding,
                'sortOrder': sortOrder,
                'drawnAreas': drawnAreas,
            },
        });
    }

    /**
     * @param customerId
     * @param forSale
     * @param headStart
     * @param sold
     * @param otherOffices
     * @returns EstateListResultModel Success
     * @throws ApiError
     */
    public static estatesGetEstatesForOffice(
        customerId?: string,
        forSale?: boolean,
        headStart?: boolean,
        sold?: boolean,
        otherOffices?: string,
    ): CancelablePromise<EstateListResultModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Estates/GetEstatesForOffice',
            query: {
                'customerId': customerId,
                'forSale': forSale,
                'headStart': headStart,
                'sold': sold,
                'otherOffices': otherOffices,
            },
        });
    }

    /**
     * @param brokerId
     * @param forSale
     * @param headStart
     * @param sold
     * @returns EstateListResultModel Success
     * @throws ApiError
     */
    public static estatesGetEstatesForBroker(
        brokerId?: string,
        forSale?: boolean,
        headStart?: boolean,
        sold?: boolean,
    ): CancelablePromise<EstateListResultModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Estates/GetEstatesForBroker',
            query: {
                'brokerId': brokerId,
                'forSale': forSale,
                'headStart': headStart,
                'sold': sold,
            },
        });
    }

    /**
     * @returns string Success
     * @throws ApiError
     */
    public static estatesCheckTimes(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Estates/CheckTimes',
        });
    }

    /**
     * @param objectType
     * @param guid
     * @param intake
     * @param from
     * @param utmSource
     * @param utmMedium
     * @param utmContent
     * @param digitalViewing
     * @param images
     * @returns string Success
     * @throws ApiError
     */
    public static estatesGetEstateUrl(
        objectType?: string,
        guid?: string,
        intake: boolean = false,
        from?: string,
        utmSource?: string,
        utmMedium?: string,
        utmContent?: string,
        digitalViewing?: string,
        images?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Estates/GetEstateUrl',
            query: {
                'objectType': objectType,
                'guid': guid,
                'intake': intake,
                'from': from,
                'utmSource': utmSource,
                'utmMedium': utmMedium,
                'utmContent': utmContent,
                'digitalViewing': digitalViewing,
                'images': images,
            },
        });
    }

    /**
     * @param objectId
     * @returns string Success
     * @throws ApiError
     */
    public static estatesGetShortObjectUrl(
        objectId?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Estates/GetShortObjectUrl',
            query: {
                'objectId': objectId,
            },
        });
    }

    /**
     * @param areaIds
     * @param municipality
     * @param county
     * @param estateType
     * @param priceMin
     * @param priceMax
     * @param monthlyCostMin
     * @param monthlyCostMax
     * @param roomsMin
     * @param roomsMax
     * @param livingSpaceMin
     * @param livingSpaceMax
     * @param showSold
     * @param showOnlyHeadStart
     * @param extraSearch
     * @param propertyType
     * @param alignment
     * @param movingIn
     * @param plotAreaMin
     * @param plotAreaMax
     * @param customerId
     * @param brokerId
     * @param showGreenEstates
     * @param showBidding
     * @param drawnAreas
     * @returns EstateListMapResultModel Success
     * @throws ApiError
     */
    public static estatesGetForFilterMap(
        areaIds?: string,
        municipality?: string,
        county?: string,
        estateType?: string,
        priceMin?: number,
        priceMax?: number,
        monthlyCostMin?: number,
        monthlyCostMax?: number,
        roomsMin?: number,
        roomsMax?: number,
        livingSpaceMin?: number,
        livingSpaceMax?: number,
        showSold?: boolean,
        showOnlyHeadStart?: boolean,
        extraSearch?: string,
        propertyType?: string,
        alignment?: string,
        movingIn?: string,
        plotAreaMin?: number,
        plotAreaMax?: number,
        customerId?: string,
        brokerId?: string,
        showGreenEstates?: boolean,
        showBidding?: boolean,
        drawnAreas?: string,
    ): CancelablePromise<EstateListMapResultModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Estates/GetForFilterMap',
            query: {
                'areaIds': areaIds,
                'municipality': municipality,
                'county': county,
                'estateType': estateType,
                'priceMin': priceMin,
                'priceMax': priceMax,
                'monthlyCostMin': monthlyCostMin,
                'monthlyCostMax': monthlyCostMax,
                'roomsMin': roomsMin,
                'roomsMax': roomsMax,
                'livingSpaceMin': livingSpaceMin,
                'livingSpaceMax': livingSpaceMax,
                'showSold': showSold,
                'showOnlyHeadStart': showOnlyHeadStart,
                'extraSearch': extraSearch,
                'propertyType': propertyType,
                'alignment': alignment,
                'movingIn': movingIn,
                'plotAreaMin': plotAreaMin,
                'plotAreaMax': plotAreaMax,
                'customerId': customerId,
                'brokerId': brokerId,
                'showGreenEstates': showGreenEstates,
                'showBidding': showBidding,
                'drawnAreas': drawnAreas,
            },
        });
    }

    /**
     * @param estateId
     * @returns EstateCardDto Success
     * @throws ApiError
     */
    public static estatesGetEstateCard(
        estateId?: string,
    ): CancelablePromise<EstateCardDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Estates/GetEstateCard',
            query: {
                'estateId': estateId,
            },
        });
    }

}
